import MUIDataTable from "mui-datatables";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Form from "../../../components/form";
import comunidade from "../../../services/comunidade";
import AppContext from "../../../container/context";

export default function Evento(props) {
  const history = props.history;
  const [id] = useState(props.match.params.id);
  const [evento, setEvento] = useState({});
  const [participantes, setParticipantes] = useState([]);
  useEffect(() => {
    carregar();
    listarParticipantes();
  }, []);
  const { notification } = useContext(AppContext);

  const carregar = () => {
    comunidade
      .get("eventos/carregar", { id: id })
      .then((evento) => {
        evento.inicio = evento.inicio ? evento.inicio.split(" ")[0] : "";
        evento.fim = evento.fim ? evento.fim.split(" ")[0] : "";
        setEvento(evento);
      })
      .catch((err) => {
        notification("error", "Erro ao carregar eventos");
      });
  };

  const listarParticipantes = () => {
    comunidade
      .get("eventos/listarParticipantes", { eventoId: id })
      .then((participantes) => {
        participantes.forEach((p) => {
          p.convidado = p.participanteCovidadoNome
            ? `${p.participanteCovidadoNome}/${
                p.participanteConvidadoContato
                  ? p.participanteConvidadoContato
                  : ""
              }`
            : "-";
          p.registro = new Date(p.participanteRegistro).toLocaleString("pt-BR");
        });
        setParticipantes(participantes);
      })
      .catch((err) => {
        notification("error", "Erro ao listar participantes");
      });
  };

  const fDados = {
    title: "Evento",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        emptyItem: true,
        value: evento.nome,
      },
      inicio: {
        label: "Data de ínicio",
        type: "date",
        space: 6,
        value: evento.inicio,
      },
      final: {
        label: "Data de fim",
        type: "date",
        space: 6,
        value: evento.fim,
      },
      areaTexto: {
        label: "Descrição",
        type: "textarea",
        value: evento.descricao,
      },
    },
    history,
    close: true,
  };

  const tCadastrosColumns =
    id === 1
      ? [
          {
            name: "localNome",
            label: "Local",
            options: {
              filter: true,
              sort: true,
            },
          },
          {
            name: "participanteNome",
            label: "Nome",
            options: {
              filter: true,
              sort: true,
            },
          },
          {
            name: "participanteCelular",
            label: "Celular",
            options: {
              filter: false,
              sort: false,
            },
          },
          {
            name: "participanteEmail",
            label: "Email",
            options: {
              filter: true,
              sort: false,
            },
          },
          {
            name: "participanteFuncao",
            label: "Função",
            options: {
              filter: true,
              sort: false,
            },
          },
          {
            name: "participanteInstituicao",
            label: "Escola",
            options: {
              filter: true,
              sort: true,
            },
          },
          {
            name: "convidado",
            label: "Convidado (nome/contato)",
            options: {
              filter: false,
              sort: false,
            },
          },
          {
            name: "registro",
            label: "Data/hora de registro",
            options: {
              filter: false,
              sort: false,
            },
          },
        ]
      : [
          {
            name: "participanteNome",
            label: "Nome",
            options: {
              filter: true,
              sort: true,
            },
          },
          {
            name: "participanteEmail",
            label: "Email",
            options: {
              filter: true,
              sort: true,
            },
          },
          {
            name: "participanteCelular",
            label: "Whatsapp",
            options: {
              filter: false,
              sort: false,
            },
          },
          {
            name: "participanteFuncao",
            label: "Cargo",
            options: {
              filter: true,
              sort: false,
            },
          },
          {
            name: "participanteInstituicao",
            label: "Escola",
            options: {
              filter: true,
              sort: false,
            },
          },
          {
            name: "participanteInstituicaoNumeroAlunos",
            label: "Número de alunos",
            options: {
              filter: true,
              sort: true,
            },
          },

          {
            name: "participanteData",
            label: "Data",
            options: {
              filter: false,
              sort: false,
            },
          },
          {
            name: "participanteHorario",
            label: "Horário",
            options: {
              filter: false,
              sort: false,
            },
          },
        ];
  return (
    <div>
      <Form formData={fDados} />
      <br />
      {evento.id > 0 && (
        <MUIDataTable
          // title="Escola Memorável - Cadastros"
          title={id === "1" ? "Escola Memorável 2022" : "Bilíngual Day 2023"}
          data={participantes}
          columns={tCadastrosColumns}
          options={tCadastrosOptions}
        />
      )}
    </div>
  );
}

const tCadastrosOptions = {
  filterType: "textField",
  selectableRows: "none",
  rowsPerPage: 50,
  downloadOptions: {
    filename: "escola-memoravel-cadastros.csv",
    separator: ";",
    filterOptions: {
      useDisplayedColumnsOnly: true,
      useDisplayedRowsOnly: true,
    },
  },
};
